import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import { Row, Col } from "antd";
import { useTranslation } from "react-i18next";
import { API_CREATE_ITEM_SERVICE } from "api/item-services-managemnt";
import { useNavigate } from "react-router-dom";
import { API_CREATE_TAX } from "api/tax-api";

const CreateTax = () => {
  const { t } = useTranslation();
  const Navigate = useNavigate();
  return (
    <>
      <div className=" mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-center">
        <div className="mt-[2vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0">
          <Formik
            initialValues={{
              tax_title: "",
              tax_charge:""
            }}
            validationSchema={Yup.object({
              tax_title: Yup.string()
                .required("Required")
                .matches(/^[^\d]+$/, "Name cannot contain numbers")
                .max(20, "Maximum character should be 20"),
            })}
            onSubmit={async (values, { setSubmitting, setFieldError }) => {
              try {
                let s = await API_CREATE_TAX(values);

                toast.success(s?.message);
                Navigate("/admin/tax/tax-tables");
              } catch (error) {
                console.error("error", error);
                toast.error(error?.response?.data?.message);
              } finally {
                setSubmitting(false);
              }
            }}
          >
            {({ isSubmitting, values, setFieldValue }) => (
              <Form className="flex min-h-[36rem] w-full flex-col justify-between rounded-[20px] bg-white p-8 shadow-md">
                <Row gutter={[16, 16]}>
                  {/* Existing fields */}
                  <Col span={8}>
                    {/* Service Name */}
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Name")}
                        <span className="text-[red]">*</span>
                      </label>
                      <Field
                        // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="tax_title"
                        placeholder={t("Name")}
                        maxLength={20}
                        onKeyPress={(event) => {
                          const charCode = event.charCode;
                          if (
                            !(charCode >= 65 && charCode <= 90) && // A-Z
                            !(charCode >= 97 && charCode <= 122) && // a-z
                            charCode !== 32 // space
                          ) {
                            event.preventDefault();
                          }
                        }}
                      />
                      <ErrorMessage
                        name="tax_title"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    {/* Service Name */}
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Tax Charge")}
                        <span className="text-[red]">*</span>
                      </label>
                      <Field
                        // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="tax_charge"
                        placeholder={t("charge")}
                        maxLength={20}
                   
                      />
                      <ErrorMessage
                        name="tax_charge"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                </Row>
                <div className="flex justify-end">
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="linear mt-2 w-full max-w-[12rem] rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                  >
                    {isSubmitting
                      ? t("Creating") + "..."
                      : t("Create Tax")}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </>
  );
};

export default CreateTax;
